import { isEqualValue } from './editDiff';

/**
 * Änderungen einer Matrix gegenüber dem Ausgangsstand (Muster „Speichern (n)" aus
 * ModulePermissionsMatrix). Reine Funktionen; der Hook dazu liegt in useChangeMap.ts.
 *
 * Ein Wert, der wieder dem Ausgangsstand entspricht, ist keine Änderung mehr.
 */
export type ChangeMap<V> = ReadonlyMap<string, V>;

export function applyChange<V>(changes: ChangeMap<V>, baseline: (key: string) => V | undefined, key: string, value: V): Map<string, V> {
  const next = new Map(changes);
  if (isEqualValue(baseline(key), value)) next.delete(key);
  else next.set(key, value);
  return next;
}

export function effectiveValue<V>(changes: ChangeMap<V>, baseline: (key: string) => V | undefined, key: string): V | undefined {
  return changes.has(key) ? changes.get(key) : baseline(key);
}

/** Entfernt Änderungen, die der neue Ausgangsstand schon enthält (nach dem Neuladen). */
export function pruneChanges<V>(changes: ChangeMap<V>, baseline: (key: string) => V | undefined): Map<string, V> {
  const next = new Map<string, V>();
  for (const [k, v] of changes) if (!isEqualValue(baseline(k), v)) next.set(k, v);
  return next;
}
